/**
 * 编辑页路由
 */
"use strict";
angular.module("atlasRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("atlas", {
        url: "/atlas?id&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@atlas": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@atlas": {
                templateUrl: "./main/submissionManage/personalLibrary/atlas/atlas_tpl.html",
                controller: "atlasCtrl"
            }
        }
    }).state("atlasdetail", {
        url: "/atlasDetail?articleId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@atlasdetail": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@atlasdetail": {
                templateUrl: "./main/submissionManage/personalLibrary/atlas/atlasDetail/atlasDetail_tpl.html",
                controller: "atlasDetailCtrl"
            }
        }
    });
}]);